import gql from 'graphql-tag'
import { client } from './api'
import { getFirstNodeLabel } from '../Screens/SupplyChainScreen/SellersJsonScreen/ReferencesScreen/utils'

export interface ReferencesResponse {
  session: { accountDisplayName: string }
  sellerDomain: { domain: string | null }
  references: Reference[]
  referencesChains: ReferenceChain[]
}

export interface Reference {
  buyerDomain: string
  seller_id: string
  seller_type?: string
  name?: string | null
  domain?: string | null
  is_confidential?: number | null
  status?: string | null
}

export interface ReferenceChain {
  id: string
  publishDate: string
  references: Reference[]
}

export interface StoredReferenceChain {
  references: { buyerDomain: string; seller_id: string }[]
}

export const getReferencesChainsQuery = gql`
  query {
    session {
      accountDisplayName
    }
    sellerDomain {
      domain
    }
    referencesChains {
      id
      publishDate
      references {
        buyerDomain
        seller_id
        name
        domain
        seller_type
        is_confidential
        status
      }
    }
  }
`

export async function getReferencesChains() {
  return client.query({
    query: getReferencesChainsQuery,
    variables: {},
    fetchPolicy: 'network-only',
  })
}

export const updateReferenceChainMutation = gql`
  mutation UpdateReference($references: [ReferenceChainReferenceInputType!]!) {
    referenceChain {
      update(references: $references)
    }
  }
`
export async function updateReferenceChain(references: StoredReferenceChain) {
  return client.mutate({
    mutation: updateReferenceChainMutation,
    variables: {
      ...references,
    },
  })
}

export const deleteReferenceChainMutation = gql`
  mutation DeleteReference($id: String!) {
    referenceChain {
      delete(id: $id)
    }
  }
`
export async function deleteReferenceChain(id: string) {
  return client.mutate({
    mutation: deleteReferenceChainMutation,
    variables: {
      id,
    },
  })
}

export function chainToLabel({
  chain,
  accountDisplayName,
  ownDeclarationDomain,
}: {
  chain: ReferenceChain
  accountDisplayName: string
  ownDeclarationDomain?: string
}): string {
  const toChainEntry = (
    reference: Reference,
    i: number,
    references: Reference[]
  ) => {
    const prevReference = references[i - 1]
    return prevReference && prevReference.is_confidential
      ? `${reference.buyerDomain} #${prevReference.seller_id}`
      : reference.buyerDomain
  }
  const firstNodeLabel = getFirstNodeLabel({
    accountDisplayName,
    ownDeclarationDomain,
    referencesFromPublisher: chain.references,
  })
  const subchainLabel = [...chain.references]
    .reverse()
    .map(toChainEntry)
    .join(' → ')
  return `${subchainLabel} → ${firstNodeLabel}`
}
